import { PropsWithChildren } from "react";
import { Button, MessageBar, MessageBarActions, MessageBarBody, MessageBarGroup, MessageBarTitle, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular,
    DismissRegular
} from "@fluentui/react-icons";
import { ILoadingErrorBarProps } from "./loading-error-bar.props";
import ApiErrorBar from "../api-error-bar/api-error-bar";

const layoutStyles = makeStyles({
    mainWrapper: {
        //...shorthands.margin('2em'),
    }
});


export default function LoadingErrorBar(props: ILoadingErrorBarProps) {
    const styles = layoutStyles();

    if (!props.error)
        return (<></>);

    return (
        <div className={styles.mainWrapper}>
            <ApiErrorBar error={props.error} />
        </div>
    );
}

